// client/src/components/AdminNavbar.js
import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import {
  FaHome,
  FaUsers,
  FaShieldAlt,
  FaLink,
  FaGift,
  FaBookOpen,
  FaUser,
  FaLifeRing,
} from 'react-icons/fa';
import { SidebarBrand } from '../shared/BrandLogo';
import '../CSS/Navbar.css';

const AdminNavbar = () => {
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' ? window.innerWidth > 768 : true
  );

  useEffect(() => {
    const onResize = () => setIsDesktop(window.innerWidth > 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <div className="sidebar-container sidebar-container--admin">
      <SidebarBrand label="Administration" />
      <div className="sidebar-item">
        <NavLink
          to="/admin-dashboard"
          end
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaHome size={20} />
          <span>Accueil</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/adminusers"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaUsers size={20} />
          <span>Users</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/adminmoderation"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaShieldAlt size={20} />
          <span>Modération</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/adminaffiliates"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaLink size={20} />
          <span>Affiliates</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/admincodepromo"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaGift size={20} />
          <span>Codepromo</span>
        </NavLink>
      </div>

      {/* ========== LIGNE CATALOGUE ========== */}
      {isDesktop && (
        <div className="sidebar-item">
          <NavLink
            to="/admincatalogpage"
            className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
          >
            <FaBookOpen size={20} />
            <span>Catalogue</span>
          </NavLink>
        </div>
      )}

      <div className="sidebar-item">
        <NavLink
          to="/adminsupport"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaLifeRing size={20} />
          <span>Support</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/adminprofil"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaUser size={20} />
          <span>Mon profil</span>
        </NavLink>
      </div>
    </div>
  );
};

export default AdminNavbar;
